var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7465 25.7C26.3332 24.78 26.6665 23.6733 26.6665 22.5C26.6665 19.1667 23.9998 16.5 20.6665 16.5C17.3332 16.5 14.6665 19.1667 14.6665 22.5C14.6665 25.8333 17.3332 28.5 20.6665 28.5C21.8265 28.5 22.9198 28.1667 23.8398 27.5933L27.9998 31.6867L29.8532 29.8333L25.7465 25.7ZM20.6665 25.8333C19.7824 25.8333 18.9346 25.4821 18.3095 24.857C17.6844 24.2319 17.3332 23.3841 17.3332 22.5C17.3332 21.6159 17.6844 20.7681 18.3095 20.143C18.9346 19.5179 19.7824 19.1667 20.6665 19.1667C21.5506 19.1667 22.3984 19.5179 23.0235 20.143C23.6486 20.7681 23.9998 21.6159 23.9998 22.5C23.9998 23.3841 23.6486 24.2319 23.0235 24.857C22.3984 25.4821 21.5506 25.8333 20.6665 25.8333ZM6.6665 27.1667V16.5H2.6665L15.9998 4.5L29.3332 16.5H26.9065C25.3332 14.86 23.1198 13.8333 20.6665 13.8333C15.8932 13.8333 11.9998 17.7267 11.9998 22.5C11.9998 24.22 12.5065 25.8333 13.3732 27.1667H6.6665Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHome);
export default __webpack_public_path__ + "static/media/search-home.8c3db55b793e4698b793d9aa676e5d00.svg";
export { ForwardRef as ReactComponent };